import { render, staticRenderFns } from "./behavior-record.vue?vue&type=template&id=6d34ad78&scoped=true"
import script from "./behavior-record.vue?vue&type=script&lang=js"
export * from "./behavior-record.vue?vue&type=script&lang=js"
import style0 from "./behavior-record.vue?vue&type=style&index=0&id=6d34ad78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d34ad78",
  null
  
)

export default component.exports